import React from 'react';
import { ClassNameMap } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Button, CircularProgress, ButtonProps } from '@mui/material';

const useStyles = makeStyles({
  root: {
    position: 'relative'
  },
  buttonProgress: {
    position: 'absolute',
    top: 'calc(50% - 12px)',
    left: 'calc(50% - 12px)'
  },
  button: {}
});

export interface ProgressButtonProps extends ButtonProps {
  classes?: ClassNameMap;
  loading: boolean;
  disable?: boolean;
}

export const ProgressButton: React.FC<ProgressButtonProps> = ({
  classes,
  loading,
  children,
  disable = false,
  onClick,
  ...rest
}: ProgressButtonProps) => {
  const styles = useStyles({ classes });

  return (
    <div className={styles.root}>
      <Button
        variant="contained"
        color="primary"
        className={styles.button}
        disabled={loading || disable}
        onClick={onClick}
        {...rest}
      >
        {children}
      </Button>

      {loading && (
        <CircularProgress
          data-testid="btn-progress"
          className={styles.buttonProgress}
          size={25}
        />
      )}
    </div>
  );
};
